import { Div } from '../../../../base/components/native/div'
import { Img } from '../../../../base/components/native/img'
import { CENTER, WH } from '../../../../base/helpers/style'

export const HowItWorksItem = (icon: string, text: string, description: string , h = 70) => {

    const base = Div()
    const img = Img(icon, {width: h})
    const placeholder = Div()
    const title = Div(text)
    const desc = Div(description)
    placeholder.append(img)
    base.append(placeholder, title, desc)

    placeholder.cssClass({
        height: '106px',
        display: 'flex',
        alignItems: 'center'
    })
    title.cssClass({
        fontSize: '24px',
        fontWeight: '700',
        margin: '20px 0 22px',
    })
    desc.cssClass({
        fontSize: '18px',
        fontWeight: '400',
        margin: '0 0 20px',
        lineHeight:'31.5px',
    })
    base.cssClass({
        ...CENTER,
        ...WH(345),
        justifyContent: 'flex-start',
        flexDirection: 'column',
        padding: '30px 30px 0 30px',
        margin: '10px',
        border: '1px solid #DDDDDD',
        borderRadius: '10px'
        
    })

    return base
}